import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const fadeUp = {
    hidden: { opacity: 0, y: 32 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
    }),
};

export function Reveal({ children, delay = 0, className = "", as = "div", ...rest }) {
    const Comp = motion[as] || motion.div;
    return (
        <Comp
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={delay}
            className={className}
            {...rest}
        >
            {children}
        </Comp>
    );
}

// Masked line-by-line reveal for hero
export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className="block overflow-hidden">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Counter({ value, suffix = "", duration = 2000 }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const [display, setDisplay] = useState(0);

    useEffect(() => {
        if (!inView) return;
        let start = null;
        let raf;
        const step = (ts) => {
            if (!start) start = ts;
            const p = Math.min((ts - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(Math.floor(eased * value));
            if (p < 1) raf = requestAnimationFrame(step);
            else setDisplay(value);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [inView, value, duration]);

    return (
        <span ref={ref}>
            {display}
            {suffix}
        </span>
    );
}
